import './components/Carousel'
import './components/DynamicForm'
import './components/Dealers'
import './components/Hero'
import './components/ImageGallery'
import './components/Popups'
import './components/CookieBar'
import { initializeFAQBlock } from './components/FAQ'
import { initializeMaps } from './components/Maps'
import initializeNewSlider from './components/slider_new'
import { Interval } from './lib/animation'
import { setCookie } from './lib/cookies' 
import { scrollToElement } from './lib/helpers'
import './pages/contactpage'
import './pages/insurancepage'

addEventListener('DOMContentLoaded', () => {
	// initCookieBar()
	initializeFAQBlock()
	initializeMaps()
	initializeMenu()
	initializeScrollToLinks()
	initializeFormDropdown()
	initializeNewSlider()
})

function initCookieBar() {
	const cookieBar = document.querySelector('#cookie-bar')

	if (!cookieBar) {
		return
	}

	const acceptButton = cookieBar.querySelector('#cookie-accept')
	const declineButton = cookieBar.querySelector('#cookie-denied')

	const confirm = (enabled = true) => setCookie('c_enabled', enabled.toString(), 30)

	acceptButton.addEventListener('click', () => {
		cookieBar.parentNode.removeChild(cookieBar)
		confirm(true)
	})

	declineButton.addEventListener('click', () => {
		cookieBar.parentNode.removeChild(cookieBar)
		confirm(false)
	})
}

function initializeMenu() {
	const nav = document.querySelector('header nav#main')
	const menu = nav.querySelector('.menu-content')
	const parentItems = [...menu.querySelectorAll('li.has-children')]

	//
	// For mobile devices.
	nav.querySelector('#hamburger')?.addEventListener('click', () => {
		nav.classList.toggle('open')
	})

	// Expanding/collapsing for mobile menu.
	for (const parentItem of parentItems) {
		parentItem.querySelector('div.expander')?.addEventListener('click', function (event) {
			event.preventDefault()
			event.stopPropagation()
			this.parentNode.parentNode.classList.toggle('expanded')
		})
	}
}

// Anchors that link to an element should start a smooth scroll animation.
function initializeScrollToLinks() {
	const anchors = [...document.body.querySelectorAll('a[href*="#"]')]

	for (const anchor of anchors) {
		anchor.addEventListener('click', function (event) {
			let [name] = this.getAttribute('href').match(/\#(.*)$/)
			name = name.replace('#', '')

			if (!name) {
				return
			}

			const targetElement = document.body.querySelector(`*[name=${name}], *[id=${name}]`)
			if (targetElement) {
				event.preventDefault()
				scrollToElement(targetElement, { offsetTop: -200 })
			}
		})
	}
}

// Adds the active class to the parent of the select for dynamicforms.
function initializeFormDropdown() {
	window.addEventListener('load', () => { // wait for stupid form-render.js
		const selects = [...document.querySelectorAll('div.fb-select.form-group select')]

		for (let i = 0; i < selects.length; i++) {
			const select = selects[i]
			select.addEventListener('focus', () => select.parentElement.classList.add('active'))
			select.addEventListener('blur', () => select.parentElement.classList.remove('active'))
		}
	})
}